/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ProfileImportItemRetryAction } from './profileImportItemRetryAction';

export interface ProfileImportItem {
  id: string;
  source_type: string;
  source_filename?: string | null;
  source_file_url?: string | null;
  source_bytes?: number | null;
  status: string;
  failure_code?: string | null;
  failure_reason?: string | null;
  retry_action?: ProfileImportItemRetryAction;
  attempt_count?: number;
  profile_id?: string | null;
  job_candidate_id?: string | null;
  created_at: string;
  updated_at: string;
  parse_duration_ms?: number | null;
  full_name?: string | null;
  headline?: string | null;
  linkedin_url?: string | null;
  github_url?: string | null;
}
